import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Link1 = ({ color = colors.gray['600'], ...props }: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6015 4.39898C17.356 2.15347 13.7153 2.15346 11.4698 4.39898L10.7627 5.10609C10.4698 5.39898 10.4698 5.87385 10.7627 6.16675C11.0556 6.45964 11.5304 6.45964 11.8233 6.16675L12.5304 5.45964C14.1902 3.79991 16.8811 3.79991 18.5408 5.45964C20.2006 7.11937 20.2006 9.81032 18.5408 11.47L16.8547 13.1562C15.3451 14.6658 12.8977 14.6658 11.3882 13.1562L11.1162 12.8843C10.8233 12.5914 10.3485 12.5914 10.0556 12.8843C9.76267 13.1772 9.76267 13.652 10.0556 13.9449L10.3275 14.2169C12.4228 16.3122 15.82 16.3122 17.9153 14.2169L19.6015 12.5307C21.847 10.2852 21.847 6.64449 19.6015 4.39898ZM7.14567 10.8445C8.65519 9.33501 11.1026 9.33501 12.6121 10.8445L12.8841 11.1165C13.177 11.4094 13.6519 11.4094 13.9448 11.1165C14.2377 10.8236 14.2377 10.3487 13.9448 10.0558L13.6728 9.78388C11.5775 7.68856 8.18032 7.68856 6.085 9.78388L4.39883 11.4701C2.15331 13.7156 2.15331 17.3563 4.39883 19.6018C6.64434 21.8473 10.285 21.8473 12.5306 19.6018L13.2377 18.8947C13.5306 18.6018 13.5306 18.1269 13.2377 17.834C12.9448 17.5411 12.4699 17.5411 12.177 17.834L11.4699 18.5411C9.81017 20.2008 7.11922 20.2008 5.45949 18.5411C3.79976 16.8814 3.79976 14.1904 5.45949 12.5307L7.14567 10.8445Z"
      fill={color}
    />
  </svg>
);

export default Link1;
